import React from 'react';
import { List } from 'semantic-ui-react';
import clsx from 'clsx';
import { findError } from '@/utils/errors';
import { propertiesWithValue } from '@/utils/resultsHelper';
import FormListItemContainer from '../../components/FormListItemContainer';

const FormObjectsListItem = ({
  autoFocus,
  canEdit,
  category,
  code,
  component,
  errors,
  field,
  fieldCount,
  fieldIndex,
  index,
  hideLabel,
  isEditing,
  onChange,
  showEdit,
  text,
  toolTip = 'top right',
}) => {
  if ((!canEdit && !text) || !component) {
    return null;
  }

  const onValueChange = (value) => onChange({ properties: propertiesWithValue(field, value), fields: [field.name] });

  const FieldComponent = component.component;
  const FieldEditor = component.editor;
  const error = findError(errors, index.toString(), [field.name]);

  return (
    <List.Item className={clsx(
      'aridhia-form-object-field-list-item',
      `form-field-item-${field.type}`,
      isEditing && 'form-editing-field-item',
    )}
    >
      <FormListItemContainer
        error={error}
        field={field}
        hasLabel={component.hasLabel}
        hideLabel={hideLabel}
        isEditing={isEditing}
      >
        <FieldComponent
          canEdit={canEdit}
          category={category}
          code={code}
          field={field}
          showEdit={showEdit}
          text={text}
          toolTip={toolTip}
          onChange={onChange}
        />
      </FormListItemContainer>
      {canEdit && isEditing && FieldEditor && (
        <FieldEditor
          autoFocus={autoFocus}
          error={error}
          field={field}
          onChange={onValueChange}
          text={text}
          upward={fieldIndex > 0 && fieldIndex === fieldCount - 1}
        />
      )}
    </List.Item>
  );
};

export default FormObjectsListItem;
